export default __webpack_public_path__ + "static/media/Flag_of_Paraguay.3b25a573.svg";